// extracted by mini-css-extract-plugin
export var clipStar = "style-mod--clip-star--5a5d2";
export var ratingText = "style-mod--rating-text--cb962";
export var yStars = "style-mod--y-stars--8ccb4";